export const eventSetupTypes = {
    SET_EVENT_SETUPS: 'SET_EVENT_SETUPS',
} as const
